import React from 'react';
import './Solution.css';
import AnimatedSection from '../AnimatedSection';
import { UsersThree, CheckCircle, ChartDonut, Gauge } from '@phosphor-icons/react';

function Solution() {
    return (
        <section className="solution" id="solution">
            <div className="solution-wrapper">
            <AnimatedSection animationType="slide-up">
                <div className="lp-section-header">
                    <h2 className="lp-section-title">
                        Your Squad’s <span className="lp-section-title-highlight">Shared Wallets</span>
                    </h2>
                    <p className="lp-section-subtitle">
                        Everything your group needs to manage money as one.
                    </p>

                </div>
            </AnimatedSection>

            {/* Mobile Features Section */}
            <div className="solution-features-mobile">
                <AnimatedSection animationType="slide-up" stagger={1}>
                    <div className="solution-feature">
                        <div className="solution-feature-icon">
                            <CheckCircle weight="regular" size={28} color="var(--green)" />
                        </div>
                        <div className='solution-feature-content'>
                            <p className="lp-section-card-label-h3">Approve in One Tap</p>
                            <p className="lp-section-card-body-p">Multisig confirmations made simple for everyone.</p>
                        </div>
                    </div>
                </AnimatedSection>
                <AnimatedSection animationType="slide-up" stagger={2}>
                    <div className="solution-feature">
                        <div className="solution-feature-icon">
                            <UsersThree weight="regular" size={28} color="var(--green)" />
                        </div>
                        <div className='solution-feature-content'>
                            <p className="lp-section-card-label-h3">Create Group</p>
                            <p className="lp-section-card-body-p">Open a shared wallet for everyday crew spending.</p>
                        </div>
                    </div>
                </AnimatedSection>
                <AnimatedSection animationType="slide-up" stagger={3}>
                    <div className="solution-feature">
                        <div className="solution-feature-icon">
                            <ChartDonut weight="regular" size={28} color="var(--green)" />
                        </div>
                        <div className='solution-feature-content'>
                            <p className="lp-section-card-label-h3">Send & Track Live</p>
                            <p className="lp-section-card-body-p">Track live with full transparency, zero confusion.</p>
                        </div>
                    </div>
                </AnimatedSection>
                <AnimatedSection animationType="slide-up" stagger={4}>
                    <div className="solution-feature">
                        <div className="solution-feature-icon">
                            <Gauge weight="regular" size={28} color="var(--green)" />
                        </div>
                        <div className='solution-feature-content'>
                            <p className="lp-section-card-label-h3">Set Goals & Rules</p>
                            <p className="lp-section-card-body-p">Define spending rules & set savings goals.</p>
                        </div>
                    </div>
                </AnimatedSection>
                <AnimatedSection animationType="scale-in" stagger={5}>
                    <div className="solution-image-wrapper">
                        <img
                            src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fsharedwallet-img.png?alt=media&token=3dd5042e-d6bb-497c-92c0-7ea977eb2646"
                            alt="WeSplit shared wallets"
                            className="solution-image"
                        />
                    </div>
                </AnimatedSection>
            </div>

            {/* Desktop Layout */}
            <div className="solution-content">
                <AnimatedSection animationType="slide-left" stagger={1}>
                    <div className="solution-feature solution-feature-create">
                        <div className='solution-feature-left'>
                            <p className="lp-section-card-label-h3">Approve in One Tap</p>
                            <p className="lp-section-card-body-p">Multisig confirmations made simple for everyone.</p>
                        </div>
                        <div className="solution-feature-icon">
                            <CheckCircle weight="regular" size={32} color="var(--green)" />
                        </div>
                    </div>
                </AnimatedSection>
                <AnimatedSection animationType="slide-left" stagger={2}>
                    <div className="solution-feature solution-feature-split">
                        <div className='solution-feature-left'>
                            <p className="lp-section-card-label-h3">Create Group</p>
                            <p className="lp-section-card-body-p">Open a shared wallet for everyday crew spending.</p>
                        </div>
                        <div className="solution-feature-icon">
                            <UsersThree weight="regular" size={32} color="var(--green)" />
                        </div>
                    </div>
                </AnimatedSection>
                <AnimatedSection animationType="scale-in" stagger={3}>
                    <div className="solution-image-wrapper">
                        <img
                            src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fsharedwallet-img.png?alt=media&token=3dd5042e-d6bb-497c-92c0-7ea977eb2646"
                            alt="WeSplit shared wallets"
                            className="solution-image"
                        />
                    </div>
                </AnimatedSection>
                <AnimatedSection animationType="slide-right" stagger={4}>
                    <div className="solution-feature solution-feature-approve">
                        <div className="solution-feature-icon">
                            <ChartDonut weight="regular" size={32} color="var(--green)" />
                        </div>
                        <div className='solution-feature-right'>
                            <p className="lp-section-card-label-h3">Send & Track Live</p>
                            <p className="lp-section-card-body-p">Track live with full transparency, zero confusion.</p>
                        </div>
                    </div>
                </AnimatedSection>
                <AnimatedSection animationType="slide-right" stagger={5}>
                    <div className="solution-feature solution-feature-track">
                        <div className="solution-feature-icon">
                            <Gauge weight="regular" size={32} color="var(--green)" />
                        </div>
                        <div className='solution-feature-right'>
                            <p className="lp-section-card-label-h3">Set Goals & Rules</p>
                            <p className="lp-section-card-body-p">Define spending rules & set savings goals.</p>
                        </div>
                    </div>
                </AnimatedSection>
            </div>
            </div>
        </section>
    );
}

export default Solution; 